var Model = require("../types/Model.js");

module.exports = Model({
	name: "persiststorage",
	listeners: listeners,
});

function listeners() {
	return {
		"persiststorage:save": save,
		"persiststorage:delete": deleteEntry,
	};
}

function save({dataId, data, targetId}) {
	this.api.persiststorage.save({dataId, data, targetId});
}

function deleteEntry({dataId, targetId}) {
	this.api.persiststorage.deleteEntry({dataId, targetId});
}
